import { useState, useEffect } from "react";
import { FaTimes, FaPlus } from "react-icons/fa";
import { fixDateFormat } from "../../../components/pc/Utils.js";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";

const User = ({
  user,
  sameAsBefore,
  saveData,
  deleteData,
  customers,
  getInstance,
}) => {
  const [addUser, setAddUser] = useState(false);
  const [customerAgreements, setCustomerAgreements] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [userChange, setUserChange] = useState({
    UserId: -1,
    UserName: -1,
    CustomerNo: "",
    Agreements: "",
  });
  const hasExistingCustomer =
    user.CustomerNo !== null &&
    user.CustomerNo !== undefined &&
    String(user.CustomerNo) !== "";
  const getCustomerName = (customerNo) => {
    const customer = customers?.find(
      (c) => String(c.CustomerNo) === String(customerNo)
    );
    return customer ? customer.CustomerName : "";
  };

  const addNewUserSetting = () => {
    console.log("Add");
    if (!addUser) {
      const existingCustomerNo = hasExistingCustomer
        ? String(user.CustomerNo)
        : "";
      setUserChange({
        UserId: user.UserId,
        UserName: user.UserName,
        CustomerNo: existingCustomerNo,
        Agreements: "",
      });
      if (existingCustomerNo) {
        const customerMatch = customers?.find(
          (c) => String(c.CustomerNo) === existingCustomerNo
        );
        setSelectedCustomer(customerMatch ? [customerMatch] : []);
      } else {
        setSelectedCustomer([]);
      }
      setCustomerAgreements([]);
    } else {
      setUserChange({
        UserId: -1,
        UserName: -1,
        CustomerNo: "",
        Agreements: "",
      });
      setSelectedCustomer([]);
      setCustomerAgreements([]);
    }
    setAddUser(!addUser);
  };

  const deleteUserSetting = (e) => {
    if (window.confirm("Är du säker på att du vill ta bort denna rad?")) {
      console.log("Delete OK");
      deleteData(user);
    } else {
      console.log("Delete Cancel");
    }
  };
  function handleChangeAgreement(evt) {
    const selectedAgreement = evt.target.value;
    setUserChange({
      ...userChange,
      Agreements: selectedAgreement,
    });
  }

  const handleCustomerSelection = (selected) => {
    if (selected.length > 0) {
      setSelectedCustomer(selected);
      setUserChange((prev) => ({
        ...prev,
        UserId: user.UserId,
        UserName: user.UserName,
        CustomerNo: `${selected[0].CustomerNo}`,
        Agreements: "",
      }));
    } else {
      setSelectedCustomer([]);
      setUserChange((prev) => ({
        ...prev,
        CustomerNo: "",
        Agreements: "",
      }));
    }
  };

  const btnSave = (e) => {
    saveData(userChange);
    setAddUser(false);
  };
  useEffect(() => {
    if (!userChange.CustomerNo) {
      setCustomerAgreements([]);
      return;
    }
    setCustomerAgreements([]);
    getInstance("AGREEMENTS", userChange.CustomerNo).then((agreements) => {
      if (agreements) {
        setCustomerAgreements(agreements);
      }
    });
  }, [userChange.CustomerNo, getInstance]);

  useEffect(() => {
    if (!userChange.CustomerNo) {
      setSelectedCustomer([]);
      return;
    }
    const customerMatch = customers?.find(
      (c) => String(c.CustomerNo) === String(userChange.CustomerNo)
    );
    setSelectedCustomer(customerMatch ? [customerMatch] : []);
  }, [userChange.CustomerNo, customers]);

  return (
    <div className="divUser">
      {sameAsBefore ? (
        <></>
      ) : (
        <>
          <div className="divLine" />
          <span className="pUserName">{user.FullName} </span>
          <span>
            -&nbsp;{user.UserName}{" "}
            <FaPlus
              className="imgAdd"
              title="Lägg till"
              onClick={addNewUserSetting}
            />
          </span>
          <p className="pLastLoggedIn">
            Senast inloggad:&nbsp;
            {user.LastLogonTimeStamp === null
              ? "-"
              : fixDateFormat(user.LastLogonTimeStamp)}
          </p>
        </>
      )}
      {user.CustomerNo === "" && user.Agreements === "" ? (
        <></>
      ) : (
        <div className="divUserName">
          Kund: {getCustomerName(user.CustomerNo)}{" "}
          <span style={{ color: "#666" }}>({user.CustomerNo})</span> Avtal:{" "}
          {user.Agreements}
          <FaTimes
            className="imgTrash"
            title="Ta bort"
            onClick={deleteUserSetting}
          />
        </div>
      )}
      {addUser ? (
        <div className="divUserName">
          {" "}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
              marginTop: "10px",
            }}
          >
            <span style={{ marginRight: "10px" }}>Kund</span>{" "}
            <Typeahead
              id={`customer-typeahead-${user.UserId ?? user.UserName}`}
              style={{ width: "80%" }}
              onChange={handleCustomerSelection}
              options={customers || []}
              labelKey={(option) =>
                `${option.CustomerName} - ${option.CustomerNo}`
              }
              placeholder="Välj kund..."
              selected={selectedCustomer}
              disabled={hasExistingCustomer}
            />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <span style={{ marginRight: "10px" }}>Avtal</span>
            <select
              className="admin-dropdown"
              onChange={handleChangeAgreement}
              value={userChange.Agreements}
              style={{ width: "80%", height: "38px", padding: "6px 12px" }}
            >
              <option value="">-- Välj avtal --</option>
              {customerAgreements.map((agreement, index) => (
                <option key={index} value={agreement.AgreementId}>
                  {agreement.AgreementName} - {agreement.AgreementId}
                </option>
              ))}
            </select>
          </div>
          <button
            className="btn"
            onClick={btnSave}
            disabled={
              userChange.CustomerNo === "" || userChange.Agreements === ""
                ? true
                : false
            }
          >
            Spara
          </button>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default User;
